/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_home_no_driver_data = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No driver data available for ${i?.season}`)
};

const es_f1_home_no_driver_data = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No hay datos de pilotos disponibles para ${i?.season}`)
};

const de_f1_home_no_driver_data = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Keine Fahrerdaten für ${i?.season} verfügbar`)
};

const nl_f1_home_no_driver_data = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geen coureurgegevens beschikbaar voor ${i?.season}`)
};

const fr_f1_home_no_driver_data = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aucune donnée de pilote disponible pour ${i?.season}`)
};

const it_f1_home_no_driver_data = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nessun dato pilota disponibile per ${i?.season}`)
};

const pt_br2_f1_home_no_driver_data = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nenhum dado de piloto disponível para ${i?.season}`)
};

const pt_f1_home_no_driver_data = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nenhum dado de piloto disponível para ${i?.season}`)
};

const ja_f1_home_no_driver_data = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.season}年のドライバーデータがありません`)
};

const zh_f1_home_no_driver_data = /** @type {(inputs: { season: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.season}年无车手数据`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ season: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_home_no_driver_data = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_home_no_driver_data(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_home_no_driver_data", locale)
	if (locale === "en") return en_f1_home_no_driver_data(inputs)
	if (locale === "es") return es_f1_home_no_driver_data(inputs)
	if (locale === "de") return de_f1_home_no_driver_data(inputs)
	if (locale === "nl") return nl_f1_home_no_driver_data(inputs)
	if (locale === "fr") return fr_f1_home_no_driver_data(inputs)
	if (locale === "it") return it_f1_home_no_driver_data(inputs)
	if (locale === "pt-BR") return pt_br2_f1_home_no_driver_data(inputs)
	if (locale === "pt") return pt_f1_home_no_driver_data(inputs)
	if (locale === "ja") return ja_f1_home_no_driver_data(inputs)
	return zh_f1_home_no_driver_data(inputs)
};